/**
 * Entities collected in the application
 */
export const EntityType = {
  Account: 'account',
  SecurityProfile: 'security-profile',
  Asset: 'asset',
  Payment: 'payment',
  Order: 'order',
  OrderItem: 'order-item',
  Enumeration: 'enumeration'
}

/**
 * User-friendly entity names
 */
export const EntityDescription = {
  [EntityType.Account]: 'Account',
  [EntityType.SecurityProfile]: 'Security Profile',
  [EntityType.Asset]: 'Asset',
  [EntityType.Payment]: 'Payment',
  [EntityType.Order]: 'Order',
  [EntityType.OrderItem]: 'OrderItem',
  [EntityType.Enumeration]: 'Enumeration'
}
